import { Alert, Flex, Text } from '@tonic-one/react';
import { ReactNode } from 'react';
const ErrorAlert = ({
  errorMsg,
  onClose,
}: {
  errorMsg: ReactNode;
  onClose: () => void;
}) => {
  return (
    <Flex m="16px 0px">
      <Alert variant="outline" severity="error" isClosable onClose={onClose}>
        <Text>{errorMsg}</Text>
      </Alert>
    </Flex>
  );
};

export default ErrorAlert;
